import BrightnessAutoIcon from '@mui/icons-material/BrightnessAuto';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

import { haptics } from '@sophocles/platform/useHaptics';

import { useColorScheme } from './ThemeSchemeProvider';

// Three-option scheme toggle: light / system / dark.  Drop anywhere
// you want to let the user pick the active appearance — user
// settings, account menu, header chrome, etc.
//
// Compact ToggleButtonGroup pattern matches the rest of the app's
// filter chips and segmented controls so it doesn't need bespoke
// styling.
const ColorSchemeToggle = ({ size = 'small' }) => {
  const { preference, setPreference } = useColorScheme();
  const handleChange = (_e, value) => {
    if (!value) return;
    haptics.selection();
    setPreference(value);
  };

  return (
    <ToggleButtonGroup size={size} exclusive value={preference} onChange={handleChange} aria-label="color scheme">
      <ToggleButton value="light" aria-label="Light">
        <Tooltip title="Light">
          <LightModeIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="system" aria-label="System">
        <Tooltip title="System">
          <BrightnessAutoIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="dark" aria-label="Dark">
        <Tooltip title="Dark">
          <DarkModeIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

ColorSchemeToggle.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default ColorSchemeToggle;
